const TitleSection = ({ children }) => {
    return(
        <div className="row">
            <div className="col-12 col-titleSection">
                {children}
            </div>
        </div>
    );
}

export default TitleSection;